/* eslint-disable @typescript-eslint/no-empty-function */
import { ColoredDot, DashboardCard, Flex, P } from 'styling/GlobalStyles'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IWidget } from 'types/dashboard.interface'
import { BodyText, OtherText, ParagraphText, TitleText } from 'styling/Typography'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { HrDashboardInnerWidgetContainer } from '../HrDashboard.styled'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { getHrDashboardNotifications } from 'features/hrDashboard/hr.slice'
import { AppDispatch, RootState } from 'store'
import { NotificationsModal } from './NotificationsModal'
import { createPortal } from 'react-dom'
import { formatDateForDisplay, formatDateWithTime } from 'utils/helpers'

export const HrNotificationWidget = ({
    modalOpen,
    removeWidget,
    onDragOver,
    onDragStart,
    onDragDrop
}: IWidget) => {

    const dispatch = useDispatch<AppDispatch>()
    const notifications = useSelector((store: RootState) => store.hrDashboard.notifications)
    const [modal, setModal] = useState(false)

    useEffect(() => {
        dispatch(getHrDashboardNotifications({ page: 1, limit: 5 }))
    }, [])

    return (
        <DashboardCard
            draggable={modalOpen}
            onDragStartCapture={() => {
                onDragStart('notifications', 1)
            }}
            onDrop={onDragDrop}
            onDragEnd={(e) => {
                e.preventDefault()
            }}
            onDragOver={(e) => {
                e.preventDefault()
                onDragOver('notifications')
            }}
            width='1fr'
            style={{ gridArea: 'notifications', cursor: modalOpen ? 'grab' : 'normal' }}
        >
            {modalOpen && (
                <WidgetEditOverlay
                    onClick={(e) => {
                        removeWidget('notifications')
                        e.stopPropagation()
                    }}
                >
                    <P>Remove Widget</P>
                    <CloseIcon white />
                </WidgetEditOverlay>
            )}
            <Flex width='100%' between className='widget-title'>
                <TitleText weight='bold'>NOTIFICATIONS</TitleText>
                {notifications?.totalCount > 5 && <OtherText onClick={() => setModal(true)} color='#ff9900' style={{ cursor: 'pointer' }} >View More</OtherText>}
            </Flex>
            <HrDashboardInnerWidgetContainer padding='0' style={{ height: '100%' }} >
                {notifications.data.length ?
                    <Flex column gap='1rem'>
                        {notifications.data.map(n => <Flex className='widget-notification' key={n.id} center between width='100%' gap='1rem' >
                            <Flex center gap='1rem' >
                                {!n.isSeen && <ColoredDot color='#FF4F46' />}
                                <BodyText>{n.message}</BodyText>
                            </Flex>
                            <ParagraphText className='time' style={{ textAlign: 'end' }} >{formatDateForDisplay(n.createdAt, true)}</ParagraphText>
                        </Flex>)}

                    </Flex> : <TitleText style={{ width: '100%', textAlign: 'center' }} >No Notifications Yet</TitleText>}
            </HrDashboardInnerWidgetContainer>
            {modal && createPortal(<NotificationsModal closeModal={() => setModal(false)} />, document.body)}


        </DashboardCard>
    )
}
